import { Required, IsString, IsNumber, IsBoolean, DataValidator, transformKeys } from "@/utils/type-vaildator";
import api from "./api";

class PushInfoUserSubscriptionSettingRaw {
  @Required("Subscribe enabled cannot be empty")
  @IsBoolean("Subscribe enabled must be a boolean")
  subscribeEnabled: boolean;

  @Required("Push count cannot be empty")
  @IsNumber("Push count must be a number")
  pushCount: number;

  @Required("Push frequency day cannot be empty")
  @IsNumber("Push frequency day must be a number")
  pushFrequencyDay: number;

  @Required("Push time cannot be empty")
  @IsNumber("Push time must be a number")
  pushTime: number;
}

export class SubscriptionSettingData {
  @Required("Is subscribed cannot be empty")
  @IsBoolean("Is subscribed must be a boolean")
  subscribeEnabled: boolean;

  @Required("Push frequency cannot be empty")
  @IsNumber("Push frequency must be a number")
  pushFrequency: number;

  @Required("Push count cannot be empty")
  @IsNumber("Push count must be a number")
  pushCount: number;

  @Required("Push time cannot be empty")
  @IsString("Push time must be a string")
  pushTime: string;
}

const transformAndValidateRaw = (response: any): PushInfoUserSubscriptionSettingRaw => {
  const transformed = transformKeys(response);
  return DataValidator.validateOrThrow(transformed, PushInfoUserSubscriptionSettingRaw);
};

const formatPushTimeRange = (hour: number): string => {
  if (hour < 0) return "";
  const start = hour % 24 === 0 ? 0 : hour % 24;
  const end = (start % 24) + 1;
  return `${start}:00 - ${end}:00`;
};

export interface GetSubscriptionSettingsRequest {
  agentId: string;
  type: "video" | "podcast" | "moments" | "post" | "article" | "image";
}

export const getSubscriptionSettings = async ({
  agentId,
  type,
}: GetSubscriptionSettingsRequest): Promise<SubscriptionSettingData> => {
  const typeMap = { video: 1, podcast: 2, moments: 3, post: 4, image: 4, article: 5 } as const;
  if (!agentId) throw new Error("agentId cannot be empty");
  if (!(type in typeMap)) throw new Error(`Invalid subscription type: ${type}`);

  const response = await api.post<any>(
    "push_info_user_subscription_setting/list",
    {
      agent_id: agentId,
      type: typeMap[type],
    }
  );

  const raw = transformAndValidateRaw(response.data);
  const pushTimeStr = formatPushTimeRange(raw.pushTime);

  return {
    subscribeEnabled: raw.subscribeEnabled,
    pushFrequency: raw.pushFrequencyDay,
    pushCount: raw.pushCount,
    pushTime: pushTimeStr,
  };
};